import { post } from '../../base';

export function getMerchantExportLink<T>(params: T) {
  return post('v3/merchants/commissions/report', { json: params })
    .json<{ link: string }>()
    .then(({ link }) => link);
}
